/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

'use strict';

angular.module('webReader')
    .directive('rdTranslateAlias', ["LocalizationService", function(LocalizationService) {
        return {
            scope: {
                rdTranslateAlias: '@'
            },
            restrict: 'A',
            replace: false,
            templateUrl: '',
            link: function($scope, element) {
                var scope = $scope;

                LocalizationService.subscribe.onLocalizationLoaded(function() {
                    $(element).html(LocalizationService.getTranslation(scope.rdTranslateAlias));
                    // console.log(LocalizationService.getTranslation(scope.rdTranslateAlias))
                    $(element).attr("placeholder", LocalizationService.getTranslation(scope.rdTranslateAlias));
                });
            }
        };
    }]);